
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'SubmitReturnSuccess'
})
export default class SubmitReturnSuccess extends Vue {
  returnOrderId = ''
  returnMoneySum = ''
  currRouteId = ''

  created() {
    this.returnOrderId = this.$route.query.returnOrderId as string
    this.returnMoneySum = this.$route.query.returnOrderMoney as string
  }

  toDetail() {
    this.$router.replace({
      path: '/mallReturnOrderDetail',
      query: {
        returnOrderId: this.returnOrderId
      }
    })
  }

  toReturnOrderList() {
    // this.$router.replace('/returnOrderList')
    // this.$router.go(-3)
    this.$router.replace({
      path: '/mallReturnOrderDetail',
      query: {
        returnOrderId: this.returnOrderId
      }
    })
  }
}
